/**
 * Legal document content - dynamically generated from templates and operator settings.
 */

import { LEGAL_DOCUMENTS, interpolateLegalTemplate } from '@webready/shared/config';

export const PRIVACY_POLICY_CONTENT = interpolateLegalTemplate(LEGAL_DOCUMENTS.privacyPolicy.content);

export const TERMS_OF_SERVICE_CONTENT = interpolateLegalTemplate(LEGAL_DOCUMENTS.termsOfService.content);

export const COOKIE_POLICY_CONTENT = interpolateLegalTemplate(LEGAL_DOCUMENTS.cookiePolicy.content);

/**
 * Parse simple markdown-like legal content to HTML
 */
function parseInlineMarkdown(text: string): string {
  return text.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    '<a href="$2" class="underline underline-offset-2 hover:opacity-90">$1</a>'
  );
}

export function parseLegalContent(text: string): string {
  const lines = text.split('\n');
  const blocks: string[] = [];
  let inList = false;
  let listItems: string[] = [];

  const flushList = () => {
    if (listItems.length > 0) {
      blocks.push(
        '<ul class="my-3 space-y-2 pl-5 list-disc list-outside">' +
          listItems.map((li) => `<li class="pl-1">${li}</li>`).join('') +
          '</ul>'
      );
      listItems = [];
    }
    inList = false;
  };

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    if (trimmed === '---') {
      flushList();
      blocks.push('<hr class="my-6 border-t border-current opacity-20" />');
      continue;
    }

    if (trimmed.startsWith('### ')) {
      flushList();
      blocks.push(`<h3 class="text-lg font-semibold mt-4 mb-2">${parseInlineMarkdown(trimmed.slice(4))}</h3>`);
      continue;
    }

    if (trimmed.startsWith('## ')) {
      flushList();
      blocks.push(`<h2 class="text-xl font-bold mt-6 mb-2">${parseInlineMarkdown(trimmed.slice(3))}</h2>`);
      continue;
    }

    if (trimmed.startsWith('# ')) {
      flushList();
      blocks.push(`<h1 class="text-2xl font-bold mb-4">${parseInlineMarkdown(trimmed.slice(2))}</h1>`);
      continue;
    }

    if (trimmed.startsWith('- ')) {
      if (!inList) inList = true;
      listItems.push(parseInlineMarkdown(trimmed.slice(2)));
      continue;
    }

    flushList();
    if (trimmed) {
      blocks.push(`<p class="my-2">${parseInlineMarkdown(trimmed)}</p>`);
    }
  }

  flushList();
  return blocks.join('');
}

